import React from "react";
import { cases } from "../data/content";
import { h2, section, shell } from "../utils/styles";
export function Results() {
  return <section id="resultados" className="bg-paper text-olive" data-id="element-150" data-mp="15fkw53h0g9fg">
      <div className={`${shell} ${section}`} data-id="element-151" data-mp="1je1ddoci1ibu">
        <p className="mb-5 text-[10px] font-bold uppercase tracking-[2px] text-[#697456] sm:mb-[25px]" data-id="element-152" data-mp="1jf3zzk2sgyly">
          Primeros resultados
        </p>
        <h2 className={h2} data-id="element-153" data-mp="1tbffeixoe4km">
          Personas que dieron sus <em className="not-italic text-lime-deep" data-id="element-154" data-mp="1ta4b8i0biusz">primeros pasos</em>
        </h2>
        <div className="mt-[35px] grid gap-3 sm:grid-cols-2 sm:gap-[18px]" data-id="element-155" data-mp="1occmtxyvtqtj">
          {cases.map(c => <article key={c.name} className="flex flex-col rounded-xl border border-paper-line p-[27px]" data-id="element-156" data-mp="230z0lv8v2ain">
              <span className="font-display text-[52px] leading-none text-[#7b9252]" aria-hidden="true" data-id="element-157" data-mp="1y4s5kxi06jfh">
                “
              </span>
              <h3 className="max-w-[290px] font-display text-2xl font-medium leading-[1.35] tracking-[-0.5px] sm:text-[25px]" data-id="element-158" data-mp="273vmpvxm0orc">
                {c.result}
              </h3>
              <small className="mt-auto pt-5 text-[10px] uppercase tracking-[1.5px] text-[#586b45]" data-id="element-159" data-mp="1r25s3kpelsnv">{c.name}</small>
            </article>)}
        </div>
        <p className="mt-[22px] text-[11px] leading-relaxed text-[#586b45]" data-id="element-160" data-mp="1vznsgmpcuzk9">
          Son experiencias individuales. Los resultados y los tiempos dependen de la implementación, la propuesta y la
          demanda.
        </p>
      </div>
    </section>;
}